{
  "error": {
    "server_connection_failed": "서버 연결에 실패했습니다.  "
  },
  "term": {
    "affects_all_instances": "{count} 개의 인스턴스에 대해 영향을 미칩니다.",
    "affects_this_instance_only": "이 인스턴스에만 영향을 미칩니다.",
    "all": "전체",
    "application": "애플리케이션",
    "applications_tc": "{n} 애플리케이션 | {n} 애플리케이션",
    "attributes": "속성",
    "bytes": "Bytes",
    "ok": "예",
    "cancel": "취소",
    "clear": "초기화",
    "cleared": "초기화됨",
    "close": "닫기",
    "confirm": "확인",
    "context_refresh": "컨텍스트 갱신",
    "context_refresh_failed": "실패",
    "context_refreshed": "컨텍스트 갱신됨",
    "delete": "삭제",
    "deleted": "삭제됨",
    "duration": "기간",
    "event": "이벤트",
    "ever": "ever",
    "execute": "실행",
    "executing": "실행 중...",
    "execution_failed": "실행 실패",
    "execution_successful": "실행 성공.",
    "failed": "실패했습니다",
    "fetching_data": "데이터 불러오는 중...",
    "fetch_failed": "데이터를 불러오지 못하였습니다.",
    "float": "Float",
    "filter": "필터",
    "hours": "{count} 시간 | {count} 시간",
    "instance": "인스턴스",
    "instances": "인스턴스",
    "instances_tc": "{count} 인스턴스 | {count} 인스턴스",
    "integer": "Integer",
    "menu": {
      "open": "메뉴 열기"
    },
    "milliseconds": "Milliseconds",
    "minutes": "{count} 분 | {count} 분",
    "percent": "퍼센트",
    "name": "이름",
    "operations": "Operations",
    "save": "저장",
    "stacktrace": "Stacktrace",
    "suppress": "비활성화",
    "time": "시간",
    "unsuppress": "활성화",
    "no_group": "그룹 없음",
    "username": "사용자명",
    "go_to_previous_page": "이전 페이지로 이동",
    "go_to_page_n": "{page} 페이지로 이동",
    "current_page": "페이지 {page}, 현재 페이지",
    "go_to_next_page": "다음 페이지로 이동",
    "no_results_for_term": "\"{term}\" 에 대한 결과가 없습니다."
  },
  "health": {
    "label": "Health status",
    "status": {
      "DOWN": "down",
      "UP": "up",
      "RESTRICTED": "restricted",
      "UNKNOWN": "unknown",
      "OUT_OF_SERVICE": "out of service",
      "OFFLINE": "offline"
    }
  },
  "time_short": {
    "unknown": "알 수 없음",
    "milliseconds": "{count}ms",
    "seconds": "{count}초",
    "minutes": "{count}분",
    "hours": "{count}시간",
    "days": "{count}일",
    "weeks": "{count}주",
    "months": "{count}개월",
    "years": "{count}년"
  }
}
